import { HttpClient } from '@angular/common/http';
import {Injectable, inject} from '@angular/core';

import {Auth} from 'aws-amplify';
import { environment } from 'src/environments/environment';



@Injectable()

export class AuthAmplifyService {

  isUserLoggedIn = false;
  loggedInUserInfo: any = {};
  userAuthTokenData: any;
  auth = Auth;
  proxyUrl:string = environment.proxyUrl
  private readonly http = inject(HttpClient);

 

  proxyLogin(){
    const authUrl = this.proxyUrl+'/auth';
    return this.http.get<any>(authUrl);
  }

  callback(code: string) {
    const url = this.proxyUrl+'/callback?code='+code;
    return this.http.get<any>(url, {observe: 'response', withCredentials: true});
  }

  async init(): Promise<any>{
    // This function is to check if user is already logged in or not
    // This function is called from app.module.ts constructor, removing this will break the app
  }
 
  async signIn() {
    await this.auth.federatedSignIn({customProvider: 'IAMProvider'})
  } 

  logout() {
    localStorage.removeItem('profileImage');
    localStorage.removeItem('profileName');
    localStorage.removeItem('aliasGroupName');
    localStorage.removeItem("profile");
    localStorage.removeItem("isProfileChanged");
    localStorage.removeItem("loggedIn");
    const authUrl = this.proxyUrl+'/logout';
    return this.http.get<any>(authUrl, {observe: 'response', withCredentials: true});
  }

  currentSession() {
    return this.auth.currentSession();
  }

  getUserLoginStatus() {
    return this.isUserLoggedIn;
  }

  setUserLoginStatus(status: boolean) {
    this.isUserLoggedIn = status;
  }
  
  setCurrentUserToken(data: any) {  
    this.userAuthTokenData = data;
  }

  getCurrentUserToken() {  
    return this.userAuthTokenData;
  }
}